import React from 'react';

import TeamMember from './TeamMember';
import { konrad, bartosz, marcin } from './personDescription';

const TeamMembers = () => {
  return (
    <div className="team">
      <div className="row justify-content-md-center">
        <TeamMember
          name="Konrad"
          position="CEO"
          description={konrad}
          image="konrad.png"
        />
        <TeamMember
          name="Bartosz"
          position="Head of Mobile"
          description={bartosz}
          image="bartosz.png"
        />
      </div>
    </div>
  );
};

export default TeamMembers;
